import { render, staticRenderFns } from "./transportRoutes.vue?vue&type=template&id=4ce39190&scoped=true&"
import script from "./transportRoutes.vue?vue&type=script&lang=js&"
export * from "./transportRoutes.vue?vue&type=script&lang=js&"
import style0 from "./transportRoutes.vue?vue&type=style&index=0&id=4ce39190&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce39190",
  null
  
)

export default component.exports